<template>
  <div class="box4">
    <pageTitle
      title="为什么博学谷能培养出好的产品经理？"
      text="拼凑的方法论≠产品技能  &nbsp;实用的真项目=高薪offer"
      titleColor="#191c47"
      titColor="#666666"
    />
    <div class="wrap">
      <div class="heng1">
        <p>课程价值</p>
        <p>项目方向</p>
        <p>实际应用</p>
      </div>
      <div class="heng2">
        <p>其他</p>
        <p>80%产品方法<br />论，理论性<br />强，实用价值<br />低</p>
        <p>
          授课老师个人<br />项目或某大厂<br />案例，方向局<br />限，案例零散<br />不系统
        </p>
        <p>只演示大厂业<br />务背景，架构<br />层面，实操难<br />以复制</p>
      </div>
      <div class="heng3">
        <p>博学谷</p>
        <p>20%理论知识，80%项目实战，紧密贴合企业实际业务需求</p>
        <p>以就业市场为导向，真实项目储备，项目资料完整</p>
        <p>通用性，复用性强，学完即用，技能更落地</p>
      </div>
      <div class="heng4">
        <p>内容<br />更精</p>
        <p>涉猎<br />更广</p>
        <p>技能<br />更实用</p>
      </div>
      <div class="shuyi"></div>
      <div class="shuer"></div>
      <div class="shusan"></div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box4 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/pm/box3/bgc.png") no-repeat;
  background-size: cover;
  .wrap {
    width: 660px;
    height: 749px;
    background-color: #ffffff;
    box-shadow: 0px 0px 40px 0px #d3d5f0;
    border-radius: 20px;
    margin: 48px auto;
    position: relative;
    .heng1 {
      width: 622px;
      margin: 0 auto;
      font-family: PingFangSC-Medium;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      display: flex;
      letter-spacing: 1px;
      color: #191c47;
      border-bottom: 2px solid #cecdff;
      p {
        padding: 40px 0 31px;
      }
      p:nth-child(1) {
        margin-left: 140px;
      }
      p:nth-child(2) {
        margin-left: 82px;
      }
      p:nth-child(3) {
        margin-left: 83px;
      }
    }
    .heng2 {
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 1px;
      height: 263px;
      display: flex;
      align-items: center;
      color: #666666;
      justify-content: start;
      p:nth-child(1) {
        margin-left: 38px;
      }
      p:nth-child(2) {
        margin: 0 32px 0 48px;
      }

      p:nth-child(4) {
        margin-left: 35px;
      }
    }
    .heng3 {
      width: 690px;
      height: 264px;
      background-image: linear-gradient(0deg, #847fff 0%, #9c99ff 100%);
      box-shadow: 0px 0px 40px 0px rgba(68, 62, 255, 0.4);
      border-radius: 20px;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 1px;
      color: #ffffff;
      display: flex;
      align-items: center;
      margin-left: -15px;
      p:nth-child(1) {
        margin: 0 33px 0 43px;
      }
      p:nth-child(2) {
        width: 152px;
      }
      p:nth-child(3) {
        width: 150px;
        margin: 0 32px;
      }
      p:nth-child(4) {
        width: 145px;
      }
    }
    .heng4 {
      display: flex;
      margin-top: 33px;
      bottom: 80px;
      p {
        width: 139px;
        height: 129px;
        background-color: #ffffff;
        box-shadow: 0px 0px 30px 0px #d2cef0;
        position: relative;
        border-radius: 10px;
        font-family: PingFang SC;
        font-size: 28px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 42px;
        letter-spacing: 1px;
        color: #191c47;
        text-align: center;

        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        &::before {
          content: "";
          display: block;
          width: 18px;
          height: 18px;
          background-color: #ffffff;

          position: absolute;
          left: 50%;
          transform: translateX(-50%) rotate(45deg);
          top: -9px;
        }
      }

      p:nth-child(1) {
        margin: 0 41px 0 139px;
      }
      p:nth-child(2) {
      }
      p:nth-child(3) {
        margin-left: 41px;
      }
    }
    .shuyi {
      width: 1px;
      height: 709px;
      background-color: #cecdff;
      position: absolute;
      top: 20px;
      left: 117px;
    }
    .shuer {
      width: 1px;
      height: 709px;
      background-color: #cecdff;
      position: absolute;
      top: 20px;
      left: 298px;
    }
    .shusan {
      width: 1px;
      height: 709px;
      background-color: #cecdff;
      position: absolute;
      top: 20px;
      left: 479px;
    }
  }
}
</style>
